module.exports = __webpack_public_path__ + "img/won-sign.d220c29f.svg";